<template>
  <div>
    <div class="card-header text-right">
      <button
        class="btn btn btn-primary"
        type="button"
        v-on:click="openAddOccupantModal"
      >
        Add Occupant
      </button>
      <form-button
        :indicator="indicator"
        v-on:clicked="markAsNoOccupants"
        v-if="!markedAsNoOccupants"
        level="danger"
        >No Occupants</form-button
      >
    </div>
    <div class="card-body">
      <div class="col-xl-12">
        <div
          class="alert alert-info"
          v-if="!hasOccupants && !markedAsNoOccupants"
        >
          <p class="mb-0">
            You haven't added any occupants. Please click the "Add Occupant"
            button to add one.
          </p>
        </div>
        <div class="alert alert-info" v-if="markedAsNoOccupants">
          <p class="mb-0">
            You have marked this hire has having no occupant. To add an
            occupant, please click the "Add Occupant" button.
          </p>
        </div>
        <table
          class="table carpenter table-bordered table-hover"
          v-if="hasOccupants"
        >
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Date of Birth</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-bind:key="index"
              v-for="(occupant, index) in occupants"
              v-on:click="openEditOccupantModal(occupant)"
            >
              <td>{{ occupant.first_name }} {{ occupant.last_name }}</td>
              <td>
                {{ occupant.type ? occupant.type.label : 'Not Provided' }}
              </td>
              <td v-text="parseDateOfBirth(occupant)"></td>
            </tr>
          </tbody>
        </table>

        <v-add-occupant
          :incident="incident"
          v-if="modals.add"
          v-on:close="closeAddOccupantModal"
          :types="types"
          :client="client"
          :positions="positions"
          v-on:added="occupantWasAdded"
        ></v-add-occupant>

        <v-edit-occupant
          :incident="incident"
          v-if="modals.edit"
          v-on:close="closeEditOccupantModal"
          :types="types"
          :occupant="editingOccupant"
          :positions="positions"
          v-on:deleted="removeOccupant"
          v-on:updated="occupantWasUpdated"
        ></v-edit-occupant>
      </div>
    </div>
  </div>
</template>
<script>
import AddOccupant from './Children/AddOccupant.vue';
import EditOccupant from './Children/EditOccupant.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    'v-add-occupant': AddOccupant,
    'v-edit-occupant': EditOccupant
  },

  data() {
    return {
      modals: {
        add: false,
        edit: false
      },
      types: [],
      positions: [],
      occupants: [],
      editingOccupant: null,
      markedAsNoOccupants: false,
      client: null,
      indicator: false
    };
  },

  computed: {
    hasOccupants() {
      return !!this.occupants.length;
    }
  },

  mounted() {
    this.mount();
  },

  methods: {
    mount() {
      window.Ajax.get('/incidents/' + this.incident)
        .then(response => {
          this.markedAsNoOccupants = !response.data.has_occupants;
        })
        .catch(error => {});

      window.Ajax.get('/incidents/' + this.incident + '/client')
        .then(response => {
          this.client = response.data;
        })
        .catch(error => {});

      window.Ajax.get('/occupant-types')
        .then(response => {
          this.types = response.data;
        })
        .catch(error => {});

      window.Ajax.get('/seat-positions')
        .then(response => {
          this.positions = response.data;
        })
        .catch(error => {});

      window.Ajax.get('/incidents/' + this.incident + '/occupants')
        .then(response => {
          this.occupants = response.data;
        })
        .catch(error => {});
    },

    parseDateOfBirth(occupant) {
      if (occupant.date_of_birth) {
        return window.DateManager.format(occupant.date_of_birth);
      }

      return 'Not Provided';
    },

    markAsNoOccupants() {
      window
        .swal({
          title: 'Are you sure?',
          text: 'This will remove all current occupants',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.indicator = true;
            window.Ajax.delete('/incidents/' + this.incident + '/occupants')
              .then(response => {
                this.occupants = [];
                this.markedAsNoOccupants = true;
                window.toastify.success(
                  'Occupants Removed',
                  'The occupants were removed successfully!'
                );
                this.indicator = false;
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error removing the occupants.'
                );
              });
          }
        })
        .catch(window.swal.noop);
    },

    findIndex(identifier) {
      return this.occupants.findIndex(item => {
        return item.identifier === identifier;
      });
    },

    removeOccupant(occupant) {
      this.closeEditOccupantModal();

      let index = this.findIndex(occupant.identifier);

      this.occupants.splice(index, 1);

      window.toastify.success(
        'Occupant Deleted',
        'The occupant was deleted successfully!'
      );
    },

    occupantWasUpdated(occupant) {
      this.closeEditOccupantModal();

      let index = this.findIndex(occupant.identifier);

      this.$set(this.occupants, index, occupant);

      window.toastify.success(
        'Success!',
        'The occupant was updated successfully!'
      );
    },

    closeEditOccupantModal() {
      this.modals.edit = false;
      this.editingOccupant = null;
    },

    openEditOccupantModal(occupant) {
      this.editingOccupant = occupant;
      this.modals.edit = true;
    },

    occupantWasAdded(occupant) {
      this.occupants.push(occupant);
      this.markedAsNoOccupants = false;
      this.closeAddOccupantModal();
      this.$emit('updated', true);
      window.toastify.success(
        'Success!',
        'The occupant was added successfully!'
      );
    },

    openAddOccupantModal() {
      this.modals.add = true;
    },

    closeAddOccupantModal() {
      this.modals.add = false;
    }
  },

  watch: {
    $route(to, from) {
      this.mount();
    }
  }
};
</script>
